import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "application-component" }
const _hoisted_2 = {
  class: "application-component-content",
  "element-loading-text": "正在思考中..."
}
const _hoisted_3 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_4 = ["innerHTML"]

import { useGlobalStore } from '@/store/modules/global'


export default {
  __name: 'StructuredContent',
  props: {
  readOnly: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => null,
  },
  projectId: {
    type: String,
    default: ''
  },
  handleAddToDetailList: {
    type: Function,
    default: () => null
  },
  handleUpdateDetailList: {
    type: Function,
    default: () => null
  }
},
  setup(__props) {

const globalStore = useGlobalStore()

const props = __props

const fontSize = computed(() => `${globalStore.fontSize}px`)


return (_ctx, _cache) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "application-component-title" }, "结构化内容", -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (__props.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_skeleton, {
              rows: 2,
              animated: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "content textselection",
            style: _normalizeStyle({fontSize: _unref(fontSize)})
          }, [
            _createElementVNode("div", {
              innerHTML: __props.data?.docResult || ''
            }, null, 8, _hoisted_4)
          ], 4))
    ])), [
      [_directive_loading, !__props.readOnly && !__props.data]
    ])
  ]))
}
}

}